import React from "react";
import { Anchor, Box, Flex, ThemeIcon } from "@mantine/core";
import { Link } from "react-router-dom";
import { IconHash } from "@tabler/icons-react";

import { PageTitle } from "@components/shared";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

export default function EntitySubtitles({ info, tags = null }) {
  if (!info) return null;
  const subtitles = [
    {
      value: info.campaign_effort_id,
      icon: entityIcon.effort(),
      color: entityColor.effort,
      name: info.campaign_effort_name,
      url: `/efforts`,
    },
    {
      value: info.campaign_id,
      icon: entityIcon.campaign(),
      color: entityColor.campaign,
      name: info.campaign_name,
      url: `/campaigns`,
    },
    {
      value: info.contest_id,
      icon: entityIcon.contest(),
      color: entityColor.contest,
      name: info.contest_name,
      url: `/contests`,
    },
    {
      value: info.organization_id,
      icon: entityIcon.organization(),
      color: entityColor.organization,
      name: info.organization_name,
      url: `/organizations`,
    },
    {
      value: info.location_id,
      icon: entityIcon.location(),
      color: entityColor.location,
      name: info.location_name,
      url: `/locations`,
    },
    {
      value: info.bulk_communicator_id,
      icon: entityIcon.send(),
      color: entityColor.send,
      name: info.bulk_communicator_name,
      url: `/bulk-communication`,
    },
  ]
    .filter((f) => f.value)
    .map((m) => ({
      ...m,
      url: `${m.url}/${m.value}`,
    }));

  return (
    <div>
      {subtitles.map((m, i) => (
        <PageTitle
          key={i}
          icon={m.icon}
          iconColor={m.color}
          style={{ marginBottom: "5px" }}
          subtitle={
            <Anchor
              style={{
                color: "inherit",
              }}
              component={Link}
              to={m.url}
              target="_blank"
            >
              {m.name}
            </Anchor>
          }
        />
      ))}
      {tags && (
        <Box mt={2}>
          <Flex align="center">
            <ThemeIcon
              size="sm"
              mr="xs"
              variant="light"
              color={entityColor.tag}
              radius="xl"
            >
              {entityIcon.tag()}
            </ThemeIcon>
            <Box style={{ flexGrow: 1 }}>{tags}</Box>
          </Flex>
        </Box>
      )}
    </div>
  );
}
